import React from "react";
import _ from "lodash";
import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow
} from "@mui/material";

function CostarInfo({ parcel }) {
  const data = JSON.parse(
    _.get(_.first(parcel.costarparcelSet.edges), "node").data
  );

  return (
    <Grid container>
      <Grid size={10}>
        <Paper elevation={1}>
          <TableContainer>
            <Table>
              <TableBody>
                {_.map(_.sortBy(_.keys(data)), key => (
                  <TableRow key={key}>
                    <TableCell>
                      <b>{_.startCase(key)}</b>
                    </TableCell>
                    <TableCell>{data[key]}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Grid>
    </Grid>
  );
}

export default CostarInfo;
